import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./DeliveryCompleteProfile.css";
import getImageUrl from "../../../utils/imageUrl";
function DeliveryCompleteProfile() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [profilePhoto, setProfilePhoto] = useState(null);

    const [photoPreview, setPhotoPreview] = useState(null);

    const [formData, setFormData] = useState({

        fullName: "",

        email: "",

        phone: "",

        dob: "",

        gender: "",

        emergencyContact: "",

        houseNumber: "",

        street: "",

        area: "",

        landmark: "",

        city: "",

        state: "",

        pincode: ""

    });

    // =====================================
    // Fetch Logged In User
    // =====================================

    useEffect(() => {

        fetchProfile();

    }, []);

    const fetchProfile = async () => {

        try {

            const response = await API.get(

                "/delivery/profile"

            );

            const data = response.data.deliveryPartner;

            const existingPhoto =
    data.profile?.photo ||
    data.profile?.profileImage ||
    "";

setPhotoPreview(
    existingPhoto
        ? getImageUrl(
            existingPhoto.includes("/uploads/")
                ? existingPhoto
                : `uploads/delivery/${existingPhoto}`
          )
        : null
);

            setFormData({

                fullName: data.userId?.name || "",

                email: data.userId?.email || "",

                phone: data.userId?.phone || "",

                dob: data.profile?.dob || "",

                gender: data.profile?.gender || "",

                emergencyContact: data.profile?.emergencyContact || "",

                houseNumber: data.address?.houseNumber || "",

                street: data.address?.street || "",

                area: data.address?.area || "",

                landmark: data.address?.landmark || "",

                city: data.address?.city || "",

                state: data.address?.state || "",

                pincode: data.address?.pincode || ""

            });

        }

        catch (error) {

            console.log(error);

        }

    };

    // =====================================
    // Handle Input
    // =====================================

    const handleChange = (e) => {

        const {

            name,

            value

        } = e.target;

        setFormData((prev) => ({

            ...prev,

            [name]: value

        }));

    };

    // =====================================
    // Upload Photo
    // =====================================

    const handlePhoto = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    setProfilePhoto(file);

    setPhotoPreview(URL.createObjectURL(file));

};
        // =====================================
    // Submit Profile
    // =====================================

   const handleSubmit = async (e) => {

    e.preventDefault();

    try {

        setLoading(true);

        const formDataToSend = new FormData();

        if (profilePhoto) {

            formDataToSend.append(
                "photo",
                profilePhoto
            );

        }

        formDataToSend.append(
            "dob",
            formData.dob
        );

        formDataToSend.append(
            "gender",
            formData.gender
        );

        formDataToSend.append(
            "emergencyContact",
            formData.emergencyContact
        );

        formDataToSend.append(
            "houseNumber",
            formData.houseNumber
        );

        formDataToSend.append(
            "street",
            formData.street
        );

        formDataToSend.append(
            "area",
            formData.area
        );

        formDataToSend.append(
            "landmark",
            formData.landmark
        );

        formDataToSend.append(
            "city",
            formData.city
        );

        formDataToSend.append(
            "state",
            formData.state
        );

        formDataToSend.append(
            "pincode",
            formData.pincode
        );

        const response = await API.patch(

            "/delivery/profile",

            formDataToSend,

           
        );

        if (response.data.success) {

            alert(

                "Profile Updated Successfully"

            );

            navigate(

                "/delivery/vehicle-bank"

            );

        }

    }

    catch (error) {

        console.log(error);

        alert(

            error.response?.data?.message ||

            "Failed to update profile."

        );

    }

    finally {

        setLoading(false);

    }

};

    return (

        <div className="delivery-profile-page">

            <div className="delivery-profile-card">

                <div className="delivery-profile-logo">

                    🚚

                </div>

                <h1 className="delivery-profile-title">

                    HomeFoods

                </h1>

                <h2 className="delivery-profile-subtitle">

                    Complete Your Profile

                </h2>

                <p className="delivery-profile-description">

                    Finish setting up your delivery partner account.

                </p>

                <form

                    className="delivery-profile-form"

                    onSubmit={handleSubmit}

                >

                    {/* Profile Photo */}

                    <div className="photo-section">

    <label
        htmlFor="profilePhoto"
        className="photo-upload"
    >

       <img
    src={
        photoPreview ||
        "/images/default-profile.png"
    }
    alt="Profile"
    className="photo-preview"
    onError={(event) => {
        event.currentTarget.src =
            "/images/default-profile.png";
    }}
/>

        <span>

            Upload Profile Photo

        </span>

    </label>

    <input

        id="profilePhoto"

        type="file"

        accept="image/*"

        hidden

        onChange={handlePhoto}

    />

</div>

                    {/* Full Name */}

                    <div className="form-group">

                        <label>

                            Full Name

                        </label>

                        <input

                            type="text"

                            value={formData.fullName}

                            readOnly

                        />

                    </div>

                    {/* Email */}

                    <div className="form-group">

                        <label>

                            Email Address

                        </label>

                        <input

                            type="email"

                            value={formData.email}

                            readOnly

                        />

                    </div>

                    {/* Mobile */}

                    <div className="form-group">

                        <label>

                            Mobile Number

                        </label>

                        <input

                            type="text"

                            value={formData.phone}

                            readOnly

                        />

                    </div>
                                        {/* Date of Birth */}

                    <div className="form-group">

                        <label>

                            Date of Birth

                        </label>

                        <input

                            type="date"

                            name="dob"

                            value={formData.dob}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* Gender */}

                    <div className="form-group">

                        <label>

                            Gender

                        </label>

                        <div className="gender-group">

                            <label className="gender-option">

                                <input

                                    type="radio"

                                    name="gender"

                                    value="Male"

                                    checked={formData.gender === "Male"}

                                    onChange={handleChange}

                                />

                                Male

                            </label>

                            <label className="gender-option">

                                <input

                                    type="radio"

                                    name="gender"

                                    value="Female"

                                    checked={formData.gender === "Female"}

                                    onChange={handleChange}

                                />

                                Female

                            </label>

                            <label className="gender-option">

                                <input

                                    type="radio"

                                    name="gender"

                                    value="Other"

                                    checked={formData.gender === "Other"}

                                    onChange={handleChange}

                                />

                                Other

                            </label>

                        </div>

                    </div>

                    {/* Emergency Contact */}

                    <div className="form-group">

                        <label>

                            Emergency Contact Number

                        </label>

                        <input

                            type="tel"

                            name="emergencyContact"

                            placeholder="Enter emergency contact"

                            value={formData.emergencyContact}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="address-title">

                        Permanent Address

                    </div>

                    {/* House Number */}

                    <div className="form-group">

                        <label>

                            House / Flat No.

                        </label>

                        <input

                            type="text"

                            name="houseNumber"

                            placeholder="House / Flat No."

                            value={formData.houseNumber}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* Street */}

                    <div className="form-group">

                        <label>

                            Street / Road

                        </label>

                        <input

                            type="text"

                            name="street"

                            placeholder="Street / Road"

                            value={formData.street}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* Area */}

                    <div className="form-group">

                        <label>

                            Area / Locality

                        </label>

                        <input

                            type="text"

                            name="area"

                            placeholder="Area / Locality"

                            value={formData.area}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* Landmark */}

                    <div className="form-group">

                        <label>

                            Landmark (Optional)

                        </label>

                        <input

                            type="text"

                            name="landmark"

                            placeholder="Nearby Landmark"

                            value={formData.landmark}

                            onChange={handleChange}

                        />

                    </div>

                    {/* City */}

                    <div className="form-group">

                        <label>

                            City

                        </label>

                        <input

                            type="text"

                            name="city"

                            placeholder="City"

                            value={formData.city}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* State */}

                    <div className="form-group">

                        <label>

                            State

                        </label>

                        <input

                            type="text"

                            name="state"

                            placeholder="State"

                            value={formData.state}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* Pincode */}

                    <div className="form-group">

                        <label>

                            Pincode

                        </label>

                        <input

                            type="text"

                            name="pincode"

                            placeholder="Pincode"

                            value={formData.pincode}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <button

                        type="submit"

                        className="delivery-profile-btn"

                        disabled={loading}

                    >

                        {

                            loading

                                ? "Saving..."

                                : "Continue"

                        }

                    </button>

                </form>

            </div>

        </div>

    );

}

export default DeliveryCompleteProfile;